import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=3899a3b2&scoped=true&"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=3899a3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899a3b2",
  null
  
)

export default component.exports